export const nonFullHeightTables: Array<string> = [
  'advertisement-controls',
  'competitors-advertisements',
  'service-ratings',
  'record-calendars-repeats',
  'record-lists-repeats',
  'advertisement-packages',
  'ad-statuses',
  'blogger-quality',
  'blogger-statuses',
  'hypothesis-types',
  'platforms',
  'product-categories',
  'product-groupss',
  'product-lines',
  'product-supplies'
];
